import { just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import InlineTextField from '../../components/InlineTextField';

interface Props {
  name: string;
  handleProductCollectionNameChange: (newName: string) => void;
}

const MAX_LENGTH = 255;

function ProductCollectionTitle({ name, handleProductCollectionNameChange }: Props) {
  return (
    <InlineTextField
      value={name}
      onChange={handleProductCollectionNameChange}
      placeholder={just('Section name')}
      emptyStateText={nothing()}
      maxLength={just(MAX_LENGTH)}
      showMaxLengthError={just(true)}
      required={just(true)}
      showRequiredError={just(true)}
      inputAriaLabel={just('Section title')}
      editIntercomTarget={just('builder-v2-edit-section-title-button')}
      emptyStateIntercomTarget={nothing()}
      style={{
        fontSize: 'var(--text-xl)',
        fontWeight: 'var(--font-weight-semibold)',
      }}
    />
  );
}

export default observer(ProductCollectionTitle);
